import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope } from 'angular';

ProgramsCombosCreateConfigureAddModalController.$inject = [
  '$scope',
  '$uibModalInstance',
  'templatesList',
  'selectedTemplatesList',
];

function ProgramsCombosCreateConfigureAddModalController(
  $scope: IScope & {
    cancel: TODO;
    done: TODO;
    errors: TODO;
    hasErrors: TODO;
    init: TODO;
    model: TODO;
    restore: TODO;
    selectedTemplates: TODO;
    selectedTemplatesList: TODO;
    success: TODO;
    templates: TODO;
  },
  $uibModalInstance: UIBModal<TODO>,
  templatesList: TODO,
  selectedTemplatesList: TODO
) {
  $scope.errors = [];

  $scope.templates = [];
  $scope.selectedTemplates = [];

  $scope.model = {
    selected: {},
  };

  $scope.init = function () {
    $scope.templates = templatesList;
    $scope.selectedTemplatesList = selectedTemplatesList;
    $scope.restore();
  };

  $scope.restore = function () {
    if ($scope.selectedTemplatesList instanceof Array) {
      for (let i = 0, ii = $scope.selectedTemplatesList.length; i < ii; i++) {
        if ($scope.selectedTemplatesList[i].id) {
          $scope.model.selected[$scope.selectedTemplatesList[i].id] = true;
        }
      }
    }
  };

  $scope.hasErrors = function () {
    return $scope.errors.length > 0;
  };

  $scope.done = function () {
    $scope.success();
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    $uibModalInstance.close($scope.model.selected);
  };

  $scope.init();
}

export const ProgramsCombosCreateConfigureAddModalControllerModule = angular
  .module('acme.view.application.programs.combos.create.configure.addModal.controllers', [])
  .controller('ProgramsCombosCreateConfigureAddModalController', ProgramsCombosCreateConfigureAddModalController).name;
